export const SELECT_ALERT_STATUS_BADGE_LABELS = {
  falsePositiveWarning: 'To flag as a false positive, click\nthe button at the top right',
} as const
